import { Component } from '@angular/core';

@Component({
  selector: 'key-listing-description',
  templateUrl: './listing-description.component.html',
})
export class KeyListingDescriptionComponent {
}
